import { googleLoginRequest } from "@/features/auth/duck/auth";
import { GoogleLogin } from "@react-oauth/google";
import { useDispatch } from "react-redux";
const GoogleLoginButton = () => {
  const dispatch = useDispatch();
  const noop = () => {};
  const googleLogin = (credentialResponse) => {
    dispatch(googleLoginRequest(credentialResponse));
  };

  return (
    <div className="w-full flex justify-center">
      <GoogleLogin
        onSuccess={(credentialResponse) => googleLogin(credentialResponse)}
        onError={noop}
        logo_alignment="center"
        size="large"
      />
    </div>
  );
};

export default GoogleLoginButton;
